var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPieOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33323 2.03667C6.21022 2.16217 5.14547 2.60221 4.26153 3.30616C3.37758 4.0101 2.71036 4.94933 2.33666 6.01575C1.96296 7.08217 1.89797 8.23243 2.14917 9.33416C2.40037 10.4359 2.95755 11.4443 3.75658 12.2433C4.55561 13.0424 5.56402 13.5995 6.66574 13.8507C7.76747 14.1019 8.91773 14.0369 9.98415 13.6632C11.0506 13.2895 11.9898 12.6223 12.6937 11.7384C13.3977 10.8544 13.8377 9.78968 13.9632 8.66667H7.33323V2.03667Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6587 6H10V2.34133C10.8436 2.64062 11.6098 3.12436 12.2427 3.75729C12.8756 4.39023 13.3594 5.15641 13.6587 6Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPieOutline);
export default __webpack_public_path__ + "static/media/ChartPieOutline.bcd1d9331604c8e2701c6919820b90c7.svg";
export { ForwardRef as ReactComponent };